import { Divider, Subtitle1 } from '@backoffice-frontend/patterns'
import { Card } from '@moia-dev/pace-web'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { AdPassengerRow } from '../components/AdPassengerRow'
import {
  getOnBoardPassengers,
  getPassengerCount,
} from '../utils/passenger-filters'
import type { AdOnBoardPassengersVehicleFragment } from './AdOnBoardPassengers.hook'

export const AdOnBoardPassengers = ({
  vehicle,
}: {
  vehicle: AdOnBoardPassengersVehicleFragment
}) => {
  const { t } = useTranslation()

  const onBoardPassengers = getOnBoardPassengers(
    vehicle.fccUpcomingWaypoints ?? [],
  )
  const onBoardPassengerCount = getPassengerCount(onBoardPassengers)

  return (
    <Card outline>
      <Subtitle1
        css={theme => ({
          marginBottom: onBoardPassengerCount > 0 ? theme.space.Space4 : 0,
        })}
      >
        {t('adFleetMap_passengerListOnBoardPassengers_caption', {
          count: onBoardPassengerCount,
        })}
      </Subtitle1>
      {onBoardPassengers.map(
        ({ customer, seats, trip, notShownUpAt }, index) => (
          <Fragment key={trip.id}>
            <AdPassengerRow
              customer={customer}
              seats={seats}
              isNoShow={!!notShownUpAt}
            />
            {index !== onBoardPassengers.length - 1 && (
              <Divider borderStyle="dashed" spacing={1} />
            )}
          </Fragment>
        ),
      )}
    </Card>
  )
}
